<template>
  <div id="site-menu"></div>
</template>

<script>
export default {
  name: 'SiteMenu',
  mounted() {
    import('./site-menu').then((siteMenu) => {
      this.$nextTick(() => {
        siteMenu.launch();
      });
    });
  },
};
</script>

<style scoped lang="scss">
$small-tablet: "768px";

#site-menu {
  position: fixed;
  top: 0;
  right: 0;
  min-width: 120px;
  min-height: 210px;
  z-index: 999;

  &::v-deep > canvas {
    max-width: 100vw;
    max-height: 100vh;
  }
}

@media (max-width: $small-tablet), (max-height: $small-tablet) {
  #site-menu {
    min-width: 60px;
    min-height: 105px;
  }

  @media (orientation: landscape) {
    #site-menu::v-deep > canvas {
      max-width: 50vw;
    }
  }
}
</style>
